"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
rxjs_1.Observable.from = rxjs_1.from;
//# sourceMappingURL=from.js.map